import { put, takeEvery, select } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { setUser } from 'actions/user';
import { editUserProfile } from 'api/profile';
import { RECRUITER } from 'constants/index';
import { startEditProfileSubmit, resolveEditProfileSubmit } from './actions';

export function* editProfileSaga(action: any) {
  const { role, token } = yield select(state => state.user);

  const recruiterInfo = {
    companyName: action.payload.companyName,
    contactPerson: action.payload.contactPerson,
    contactPersonTitle: action.payload.contactPersonTitle,
    phoneNumber: action.payload.phoneNumber,
    recruitingLicence: action.payload.recruitingLicence,
  };

  const employerInfo = {
    companyName: action.payload.companyName,
    contactPerson: action.payload.contactPerson,
    contactPersonTitle: action.payload.contactPersonTitle,
    phoneNumber: action.payload.phoneNumber,
    companyBio: action.payload.companyBio,
  };

  const userInfo = {
    addressInfo: {
      address: action.payload.address,
      city: action.payload.city,
      province: action.payload.province,
      postalCode: action.payload.postalCode,
    },
    info: role === RECRUITER ? recruiterInfo : employerInfo,
  };

  try {
    const userProfile = yield editUserProfile(userInfo, token);

    yield put(resolveEditProfileSubmit());
    yield put(setUser(userProfile.data));
    yield put(push('/profile'));
  } catch (error) {
    yield put(resolveEditProfileSubmit(error.response));
  }
}

export default function* profileSaga() {
  yield takeEvery(startEditProfileSubmit, editProfileSaga);
}
